import { render, staticRenderFns } from "./specials.vue?vue&type=template&id=aaecffc8&scoped=true"
import script from "./specials.vue?vue&type=script&lang=js"
export * from "./specials.vue?vue&type=script&lang=js"
import style0 from "./specials.vue?vue&type=style&index=0&id=aaecffc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaecffc8",
  null
  
)

export default component.exports